import { useCountdownTimer } from '../hooks/use-countdown-timer';
import { formatCountdown } from '../lib/format-countdown';

type CountdownProps = {
    deadlineAt: number;
    onFinish?: () => void;
};

export function Countdown({ deadlineAt, onFinish }: CountdownProps) {
    const { remaining } = useCountdownTimer({ deadlineAt, onFinish });

    return <>{formatCountdown(remaining)}</>;
}
